import { render, staticRenderFns } from "./mergeAcount.vue?vue&type=template&id=c25cdd14&scoped=true"
import script from "./mergeAcount.vue?vue&type=script&lang=js"
export * from "./mergeAcount.vue?vue&type=script&lang=js"
import style0 from "./mergeAcount.vue?vue&type=style&index=0&id=c25cdd14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25cdd14",
  null
  
)

export default component.exports